import { useDataLoader } from "2g-hooks/fetch";

import { DATA } from "b2b/api/paths";

export default function useZadostiFaze() {
  return useDataLoader({
    url: DATA.zadostiFaze(),
    method: "get"
  });
}
